module.exports = __webpack_public_path__ + "img/PMK_20240401_1.1e7e5e68.png";